import { Component, OnDestroy, OnInit } from '@angular/core';
import { AgmMap } from '@agm/core';
import * as moment from "moment-timezone";
import { DriversService } from '../drivers-service/drivers-service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { Navigation, Router } from '@angular/router';

@Component({
  selector: 'app-driver-tracking',
  templateUrl: './driver-tracking.component.html',
  styleUrls: ['./driver-tracking.component.css']
})
export class DriverTrackingComponent implements OnInit, OnDestroy {
  driverList = [];
  user: any;
  searchDriver;
  selectedDriver: any;
  todayDate: any;
  timeZone: any
  bounds: any = null;
  latitude = 37.4316;
  longitude = -78.6569;
  zoom = 8;
  polylinePath = []
  actualPolylinePath
  driver: any;
  isFilter = false;
 tripColors = [
  '#FF0000', // Bright Red
  '#00FF00', // Bright Lime
  '#FFFF00', // Yellow
  '#FF00FF', // Magenta
  '#00FFFF', // Cyan
  '#FFA500', // Orange
  '#800080', // Purple
  '#008000', // Strong Green
  '#000000', // Black
  '#FFC107', // Amber
  '#E91E63', // Pink
  '#FF5722', // Deep Orange
  '#9C27B0', // Deep Purple
  '#795548', // Brown
  '#607D8B', // Blue Grey
  '#CDDC39', // Lime Green
  '#FF1493', // Deep Pink
  '#B22222', // Firebrick
  '#008B8B', // Dark Cyan
  '#FF4500', // Orange Red
  '#2E8B57', // Sea Green
  '#DAA520', // Goldenrod
  '#800000', // Maroon
  '#A52A2A'  // Strong Brown
];


  constructor(
    private router: Router,
    private sharedDataService: SharedDataService,
    private driverService: DriversService,
  ) {
    const navigation: Navigation = this.router.getCurrentNavigation();
    if (navigation && navigation.extras && navigation.extras.state && navigation.extras.state['driver']) {
      this.driver = navigation.extras.state['driver'];
    }
  }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.todayDate = [
            moment().tz(this.user.timeZone).startOf('day').toISOString(),
            moment().tz(this.user.timeZone).endOf('day').toISOString(),
          ];
          this.getDriverList();
          if (this.driver) {
            this.selectedDriver = this.driver;
            this.getDriverTrail(this.driver._id)
          }
        }
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
          // this.fetchSms(this.driverList[0])
        }
      });
  }

  selectDriver(driver: any) {
    this.selectedDriver = driver;
    this.getDriverTrail(driver._id)
  }

  getDriverTrail(driverId) {
    let queryParams = {
      scheduleTime: this.todayDate.toString(),
      driverId
    }
    this.driverService.getDriverTrail(queryParams).subscribe((data) => {
      if (data) {
        // Planned path from drivertrail
        this.polylinePath = data.drivertrail.map((point: any) => ({
          lat: point.latitude,
          lng: point.longitude,
        }));

        // Actual traveled paths from all trails
        this.actualPolylinePath = [];  // Change: array of arrays

        if (data.trails && data.trails.length > 0) {
          data.trails.forEach((trail: any) => {
            if (trail.trails && trail.trails.length > 0) {
              const path = trail.trails.map((str: string) => {
                const [lat, lng] = str.split(',').map(Number);
                return { lat, lng };
              });
              this.actualPolylinePath.push({ path: path, visible: false });
            }
          });
        }
        // You can adjust bounds based on both paths if you want
        this.setMapBounds(this.polylinePath);
      }
    });
  }


  setMapBounds(path: { lat: number; lng: number }[]) {
    if (!path || path.length === 0) return;

    const lats = path.map(p => p.lat);
    const lngs = path.map(p => p.lng);

    this.bounds = {
      north: Math.max(...lats),
      south: Math.min(...lats),
      east: Math.max(...lngs),
      west: Math.min(...lngs)
    };
  }

  onDateChange(event: any) {
    this.todayDate = [
      event.startOf('day').toISOString(),
      event.endOf('day').toISOString(),
    ]
    if (this.selectedDriver) {
      this.getDriverTrail(this.selectedDriver._id)
    }
  }

  toggleSelectAll() {
    const allSelected = this.actualPolylinePath.every(trip => trip.visible);
    this.actualPolylinePath.forEach(trip => trip.visible = !allSelected);
}

isAllSelected(): boolean {
    return this.actualPolylinePath.every(trip => trip.visible);
}
  ngOnDestroy(): void {

  }
}
